<div class="w-full bg-marty-green text-white">
    <div class="px-4 py-6 text-sm text-center text-white">
        <div class="text-center">
            <div class="mb-4 flex justify-center gap-3">
                <a href="{{ link.page || link.link }}" target="{{ link.target || '_blank' }}" *ngFor="let link of links" title="{{ link.label }}" (click)="navigateToPageByGenericUrl(link.page || link.link, link.target || '_blank', link.options)">{{ link.label }}</a>
            </div>
            <div>
                <div class="w-[600px] max-w-[90%] mx-auto">
                    <p class="mb-4 text-white">{{ text }}</p>
                    <p class="text-white">&#169; {{ year }} {{ brand }}. All Rights Reserved</p>
                </div>
            </div>
        </div>
    </div>
</div>